<template>
  <div class="theme-toggle">
    <button
      class="flex items-center gap-2 px-3 py-2 rounded-lg bg-secondary text-secondary-foreground active:scale-95 transition-all"
      :title="$t('profile.theme.toggle_tooltip')"
      @click="cycleTheme"
    >
      <SunIcon v-if="profileStore.getEffectiveTheme() === 'light' && profileStore.theme !== 'system'" class="w-5 h-5" />
      <MoonIcon v-else-if="profileStore.getEffectiveTheme() === 'dark' && profileStore.theme !== 'system'" class="w-5 h-5" />
      <ComputerDesktopIcon v-else class="w-5 h-5" />
      <span class="text-sm font-medium">
        {{ themeLabel }}
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useProfileStore, type ThemeType } from '../stores/profileStore'
import { SunIcon, MoonIcon, ComputerDesktopIcon } from '@heroicons/vue/24/outline'
import { useI18n } from 'vue-i18n'

const profileStore = useProfileStore()
const { t } = useI18n()

const themeLabel = computed(() => {
  const theme = profileStore.theme
  switch (theme) {
    case 'light':
      return t('profile.theme.light')
    case 'dark':
      return t('profile.theme.dark')
    case 'system':
      return t('profile.theme.system')
    default:
      return t('profile.theme.system')
  }
})

const cycleOrder: ThemeType[] = ['light', 'dark', 'system']

function cycleTheme() {
  const currentIndex = cycleOrder.indexOf(profileStore.theme)
  const nextIndex = (currentIndex + 1) % cycleOrder.length
  profileStore.setTheme(cycleOrder[nextIndex])
}
</script>
